module.exports = __webpack_public_path__ + "img/formato.7051c89c.svg";